import {
  UPDATE_NOMINATION_FAILURE,
  UPDATE_NOMINATION_REQUEST,
  UPDATE_NOMINATION_RESET,
  UPDATE_NOMINATION_SUCCESS,
} from "../../../types/awards"

const initialState = {
  loading: false,
  message: "",
  error: "",
  success: false,
}

const updateNominationReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_NOMINATION_REQUEST:
      return {
        ...state,
        loading: true,
        message: "",
        error: "",
        success: false,
      }

    case UPDATE_NOMINATION_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload.message,
        error: "",
        success: true,
      }

    case UPDATE_NOMINATION_FAILURE:
      return {
        ...state,
        loading: false,
        message: "",
        error: action.payload.error,
        success: false,
      }

    case UPDATE_NOMINATION_RESET:
      return {
        ...initialState,
      }

    default:
      return state
  }
}

export default updateNominationReducer
